
module.exports = {
	CREATE_RESET_REQUEST: "CREATE_RESET_REQUEST",
	CREATE_RESET_SUCCESS: "CREATE_RESET_SUCCESS",
	CREATE_RESET_ERROR: "CREATE_RESET_ERROR",
	CLEAR_CREATE_RESET_ERROR: "CLEAR_CREATE_RESET_ERROR"
};


// WEBPACK FOOTER //
// ./src/common/modules/password/constants.js